/* **A card's eyebrow** — the small uppercase label every card on this screen opens with.
 *
 * A stylesheet with no component, in this feature rather than in `shared/`, because it is not a
 * house treatment: it is KANON `Detal klienta`'s ONE card eyebrow (`v.lab`, read by every one of
 * that file's twenty card heads) and nothing outside this screen draws it. `photoBox.module.css`
 * is the idiom; the scope is what differs.
 *
 * 10px / 700 / .13em, uppercase, tertiary ink. It takes the head's slack (`flex: 1`) and ellipsises
 * rather than wrapping, so a long section name cannot push the control beside it out of the row.
 *
 * ── Why it is a file and not two identical blocks ────────────────────────────────────────────
 * `DetailTab.module.css` and `SummaryColumn.module.css` carried these twelve declarations byte for
 * byte, which is the same one label at the same size in two stylesheets belonging to ONE screen.
 * The eyebrow has already been re-decided once — it read 10.5px / 600 / .14em until 31 August 2026,
 * when it was put on the canon's value because TWOJA NOTATKA O KLIENCIE and TONAŻ were the same
 * label at two weights one tab apart. The next such decision now has one place to land.
 *
 * `OverviewTab.module.css` keeps its own and is NOT folded in here. It is the same size — its
 * `--fs-label-sm` and this `--fs-badge` are both 10px, which is a second finding, about the tokens
 * — but it declares none of the three overflow properties, so adopting this file would change how a
 * long eyebrow behaves on Przegląd from wrapping to ellipsising. That is a visual decision and it
 * belongs to the owner, not to a de-duplication round.
 *
 * The ink is `--text-3` here and the tab's standing contrast deviation does not apply: that
 * deviation is about `--text-2` on eyebrows, asides and captions elsewhere, and it is recorded in
 * `DetailTab.module.css`'s own header. */

.eyebrow {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-size: var(--fs-badge);
  font-style: normal;
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-3);
  letter-spacing: var(--ls-lab);
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

/* **The wrapping variant**, for a card whose eyebrow is the trainer's own QUESTION rather than a
 * section name.
 *
 * Owner, 16 September 2026, of „CZY WYKONAŁEŚ WSZYS…": a chart card whose head is cut off has
 * stopped saying what it measures, which is the one thing a head is for. A section name is short by
 * construction and still ellipsises; a question is a sentence and wraps.
 *
 * It lives HERE, in the file that declares the three overflow properties it undoes, rather than in
 * the surface's own stylesheet: a declaration living in a shared module and in a surface's is
 * settled by CHUNK ORDER, which differs between the dev server and the build. Same file, same
 * chunk, source order decides — and the two-class selector makes that explicit.
 *
 * The caller reserves the two-line box. `text-wrap: pretty` is what keeps a three-word question
 * from leaving one word alone on the second line. */
.eyebrow.eyebrowWrap {
  flex: none;
  align-self: stretch;
  overflow: visible;
  white-space: normal;
  text-wrap: pretty;
}
